document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[js-tax-switcher="button"]').forEach((switcher) => {
    switcher.addEventListener('click', (event) => {
      const parent = switcher.closest('.tax-selector');

      parent.querySelector('[js-tax-switcher="switcher"]').classList.toggle('hidden');
    });
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.tax-selector')) {
      document.querySelectorAll('[js-tax-switcher="switcher"]').forEach((switcherElement) => {
        switcherElement.classList.add('hidden');
      });
    }
  });
  document.querySelectorAll('.header-tax .tax-switch-link').forEach((switcher) => {
    switcher.addEventListener('click', () => {
      document.querySelector('body').classList.toggle('tax-off');
      document.querySelector('body').classList.toggle('tax-on');
    });
  });
});
